import {
  GoogleOutlined,
  KeyOutlined,
  LockOutlined,
  MailOutlined,
} from "@ant-design/icons";
import { Button, Card, Col, Input, message, Row, Space } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setOnboardingStatus } from "../components/Onboarding/Onboarding";

import { getSupaClient } from "../lib/supabase";
import { logout } from "../utils/general";
import { H } from "highlight.run";

const Signup = () => {
  const supabase = getSupaClient();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleSignUp = async () => {
    logout();
    const { user, error } = await supabase.auth.signUp({ email, password });

    if (user) {
      //console.log("auth.js user", user);
      setOnboardingStatus(user.email, "choose-platform");
      window.posthog.people.set({ email: user.email });
      H.identify(user.email);
      window.analytics.identify(user.id, {
        email: user.email,
      });
      window.window.analytics.track("Initial Sign up");
      window.posthog.capture("Initial Sign up");
    }
    if (error) console.log("auth.js error", error);

    if (error) {
      console.log("in error section", error);
      message.error(`Error: ${error.message}`);
      return null;
    }
    if (!user && !error) {
      console.log("in email section");
      message.success(`"An email has been sent to you for verification!"`);
      return null;
    }
    console.log("in redirect section");
    return navigate("/onboarding");
  };

  const handleOAuthSignup = async () => {
    logout();
    // You need to enable the third party auth you want in Authentication > Settings
    // Read more on: https://supabase.io/docs/guides/auth#third-party-logins
    const { user, error } = await supabase.auth.signIn(
      {
        provider: "google",
      },
      {
        redirectTo: `${process.env.REACT_APP_URI}/oauth-signup`,
      }
    );
    if (error) {
      console.log("Error: ", error.message);
      message.error(`Error: ${error.message}`);
      return null;
    }
    return null;
  };

  return (
    <Row
      type="flex"
      justify="center"
      align="middle"
      style={{ minHeight: "100vh", padding: "0 200px" }}
    >
      <Card style={{ textAlign: "center", paddingTop: 20 }}>
        <h3>Let&#39;s get you set up! 😃</h3>
        <Row align="middle" justify="center">
          <Col lg={15} md={11} sm={24} style={{ padding: "0 20" }}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <div style={{ width: "90%", padding: 30 }}>
                <img className="fit-width" alt="sing in" src="/analyse.png" />
              </div>
            </div>
          </Col>
          <Col lg={9} md={13} sm={24} style={{ margin: "auto" }}>
            <form
              onSubmit={(e) => {
                e.preventDefault();
                handleSignUp().catch(console.error);
              }}
            >
              <Space style={{ width: "100%" }} size={12} direction="vertical">
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div>
                    <img src="/logo.png" width="150" alt="logo" />

                    <Button
                      style={{ marginTop: 20 }}
                      type="link"
                      href="/signin"
                    >
                      Trying to sign in?
                    </Button>
                  </div>
                </div>
                <Input
                  placeholder="Email"
                  size="large"
                  prefix={<MailOutlined />}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  style={{ width: "100%", borderRadius: 5 }}
                />

                <Input.Password
                  prefix={<KeyOutlined />}
                  size="large"
                  placeholder="Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  style={{ width: "100%", borderRadius: 5 }}
                />

                <Button
                  style={{ borderRadius: 5 }}
                  size="large"
                  icon={<LockOutlined />}
                  block
                  type="primary"
                  htmlType="submit"
                >
                  Sign up
                </Button>

                <p>or</p>
                <Button
                  style={{ borderRadius: 5, marginTop: -20 }}
                  size="large"
                  icon={<GoogleOutlined />}
                  block
                  onClick={() => handleOAuthSignup()}
                >
                  Sign Up with Google
                </Button>
              </Space>
            </form>
          </Col>
          <br />
          <div
            style={{
              background: "#FFFFFF",
              fontSize: 12,
              bottom: 0,
              textAlign: "center",
              justifyContent: "space-evenly",
              fontWeight: "500",
              position: "absolute",
              marginBottom: "1.7rem",
            }}
          >
            Use chat, <a href="https://discord.gg/WJFTPtvGGw"> discord</a>, or
            <a href="mailto:hello@dots.community"> email </a> for help!
          </div>
        </Row>
      </Card>
    </Row>
  );
};

export default Signup;
